import { useAuth } from '../contexts/AuthContext';
import useNewClientPause from './useNewClientPause';
import { isCustomerType } from '../utils/userType';

/**
 * True when tour scheduling is paused for the current user. While the
 * new-client pause is active, ALL direct buyers are blocked from booking
 * tours — existing clients included, not just waitlisted signups. Mirrors the
 * backend guard (apps/homepoint-api/src/hooks/before/block-waitlisted.ts,
 * blockBuyerToursDuringPause) — the backend is the enforcement; this only
 * drives UX.
 */
const useToursPaused = (): boolean => {
  const { currentUser } = useAuth();
  const { pauseActive } = useNewClientPause();

  return pauseActive && isCustomerType(currentUser?.type);
};

export default useToursPaused;
